import React from 'react'
import CallReg from './CallReg'
import '../../Css/Signup-login.css'
import Enrollcourse from '../../Pages/Enrollcourse/Enrollcourse'
import { useAccessCard } from '../../ContextProvider/Accesscardprovider'
import Pdfcard from '../../Pages/Course/Pdfcard'
import Audiocard from '../../Pages/Course/Audiocard'
import Quizcard from '../../Pages/Course/Quizcard'
import Quizsubmit from '../../Pages/Course/Quiz/Quizsubmit'

const Card = ({
    handleClick,
    enroll,
    accessEnrollCourse,
    accessCallReg,
    showCallReg,
    accessCard
}) => {

    const {
        pdf,accessPdfCard,
        audio,accessAudioCard,
        quiz,accessQuizCard,
        quizsubmit,accessQuizSubmit,
        google,setGoogle
    } = useAccessCard();

    let content;

    if (enroll) {
        content = (
            <div className='Enroll-Container'>
                <span className='close-card' onClick={() => { accessCard(); accessEnrollCourse(); handleClick(null) }}>X</span>
                <Enrollcourse accessCard={accessCard} accessEnrollCourse={accessEnrollCourse} handleClick={handleClick} />
            </div>
        );
    } else if(quiz){
        content = (
            <div className='Enroll-Container'>
                <span className='close-card' onClick={() => { accessCard(); accessQuizCard();}}>X</span>
                <Quizcard />
            </div>
        );
    }else if(pdf){
        content = (
            <div className='Enroll-Container'>
                <span className='close-card' onClick={() => { accessCard(); accessPdfCard();}}>X</span>
                <Pdfcard />
            </div>
        );
    }else if(audio){
        content = (
            <div className='Enroll-Container'>
                <span className='close-card' onClick={() => { accessCard(); accessAudioCard();}}>X</span>
                <Audiocard />
            </div>
        );
    }
    else if(quizsubmit){
        content = (
            <div className='quiz-containers'>
                <Quizsubmit />
            </div> 
        );
    }
    else if (showCallReg) {
        content = (
            <div className='Call-Reg-Container'>
                <span className='close-card' onClick={() => { accessCard(); accessCallReg(); }}>X</span>
                <CallReg accessCallReg={accessCallReg} accessCard={accessCard} />
            </div>

        );
    }

    return (
        <div>
            {content}
        </div>
    )
}

export default Card